import React, { useState, useEffect } from 'react';

import { makeStyles } from "@material-ui/core/styles";
import TableSpc from "components/TableSpc/TableSpc.js";
import { Modal, Form, Col, Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import GetAppIcon from "@material-ui/icons/GetApp";
import FileUploadIcon from "@material-ui/icons/Publish";
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";
import { Input } from '@material-ui/core';
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";


import api from "assets/services/api";

import ModalDesaprovedSpc from "components/ModalDesaprovedSpc/ModalDesaprovedSpc";
import ModalUpdateSpc from "components/ModalUpdateSpc/ModalUpdateSpc";


const styles4 = {
    tp: {
        marginTop: "10px",
    },
    upload: {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#000000",
        backgroundColor: "transparent",
        marginTop: "10px",
        border: "none",
    },
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    }
};

const useStyles2 = makeStyles(styles2);
const useStyles4 = makeStyles(styles4);

function ModalViewContacts(props) {

    const classes2 = useStyles2();
    const classes4 = useStyles4();

    const [index, setIndex] = useState({ id: 0 });
    const id_client = props.props.id
    const social_reason = props.props.social_reason
    const [modalDesaprovedSpc, setModalDesaprovedSpc] = useState(false);
    const [modalUpdateSpc, setModalUpdateSpc] = useState(false);
    const [spc, setSpc] = useState([])
    const [fileSpc, setFileSpc] = useState(null)
    const [fileSpcName, setFileSpcName] = useState("")
    //const [selectedItemId, setSelectedItemId] = useState(null);
    //const [teste, setTeste] = useState([]);

    useEffect(() => {
        loadSpc(props)
    }, [])

    useEffect(() => {
        props.getAllClients()
    }, [spc])



    async function loadSpc(props) {
        const spc = await api.get('/client/spc/' + id_client)
        setSpc(spc.data)
    }

    async function downloadSpc(id_spc) {
        await api
            .get("/client/spc/download/" + id_client + '/' + id_spc, {
                responseType: "blob",
            })
            .then(function (response) {
                let blob = new Blob([response.data], {
                    responseType: "arraybuffer",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/pdf",
                    },
                });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "Consulta SPC - " + social_reason + ".pdf"
                link.click();
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    async function handleFileUpload(event) {
        const formData = new FormData();
        formData.append('pdf', event.target.files[0]);
        setFileSpc(formData)
        setFileSpcName(event.target.files[0].name)
    }

    async function uploadSPC(id_spc) {
        const response = await api.post('/pdf/' + id_client + '/' + id_spc, fileSpc, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        if (response.status === 200) {
            setFileSpcName(null)
            await loadSpc()
        }

    }

    async function addSpc(index) {
        const response = await api.post('/spc', {
            id_client: id_client
        })
        if (response.status === 200) {
            await loadSpc()
        }
    }

    function callModalDesaprovedSpc(index) {
        setIndex(index)
        setModalDesaprovedSpc(true)
    }

    function callModalUpdateSpc(index) {
        setIndex(index)
        setModalUpdateSpc(true)
    }



    function getSpc() {
        let teste = [];
        if (spc) {
            for (let i = 0; i < spc.length; i++) {
                teste[i] = [];
                teste[i].push(
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox" >
                            <Form.Label >Upload</Form.Label>
                            <Form.Group as={Col} controlId="formGridBox" >
                                <Tooltip
                                    id="tooltip-top"
                                    title={"Upload SPC"}
                                    placement="top"
                                    classes={{ tooltip: classes2.tooltip }}
                                >
                                    <IconButton
                                        aria-label="Done"
                                        className={classes2.tableActionButton}
                                        onClick={() => uploadSPC(spc[i].id)}
                                    >
                                        <FileUploadIcon
                                            className={
                                                classes2.tableActionButtonIconDownload +
                                                " " +
                                                classes2.edit4 +
                                                " " +
                                                classes4.tp
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Form.Label placement="top" htmlFor="contained-button-file" className={classes2.labelInputUpload}>{fileSpcName ? fileSpcName : "Selecione o arquivo"}</Form.Label>
                                <Input
                                    type="file"
                                    id="contained-button-file"
                                    placement="top"
                                    className={classes2.inputUpload}
                                    onChange={handleFileUpload}
                                />

                            </Form.Group>
                        </Form.Group>
                    </Form.Row>
                );
                teste[i].push(
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox">
                            <Form.Group as={Col} controlId="formGridBox">
                                <Tooltip
                                    id="tooltip-top"
                                    title={"Download SPC"}
                                    placement="top"
                                    classes={{ tooltip: classes2.tooltip }}
                                >
                                    <IconButton
                                        aria-label="Done"
                                        className={classes2.tableActionButton}
                                        onClick={() => downloadSpc(spc[i].id)}
                                    >
                                        <GetAppIcon
                                            className={
                                                classes2.tableActionButtonIconDownload +
                                                " " +
                                                classes2.edit4 +
                                                " " +
                                                classes4.tp
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                            </Form.Group>
                        </Form.Group>
                    </Form.Row>
                )
                teste[i].push(
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridBox"><Tooltip
                            id="tooltip-top"
                            title="Aprovar"
                            placement="top"
                            classes={{ tooltip: classes2.tooltip }}
                        >
                            <IconButton
                                aria-label="Edit"
                                className={classes2.tableActionButton}
                                onClick={() => callModalUpdateSpc(spc[i])}

                            >
                                <DoneIcon
                                    className={
                                        classes2.tableActionButtonIcon + " " + classes2.edit8
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridBox"><Tooltip
                            id="tooltip-top"
                            title="Desaprovar"
                            placement="top"
                            classes={{ tooltip: classes2.tooltip }}
                        >
                            <IconButton
                                aria-label="Edit"
                                className={classes2.tableActionButton}
                                onClick={() => callModalDesaprovedSpc(spc[i])}

                            >
                                <ClearIcon
                                    className={
                                        classes2.tableActionButtonIcon + " " + classes2.edit7
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                        </Form.Group>
                    </Form.Row>
                )
                teste[i].push(
                    <CardIcon>
                        <Icon title={spc[i].validated_admin ? "Validado" : "Não validado"}>{spc[i].validated_admin ? "done" : "clear"}</Icon>
                    </CardIcon>
                )

            }
            return teste;
        }
        return teste;
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Consultas SPC de {props.props.social_reason}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <TableSpc
                    tableHeaderColor="primary"
                    tableHead={["Enviar SPC", "Baixar SPC", "Validar", "Status"]}
                    tableData={getSpc()}
                />
            </Modal.Body>
            <Modal.Footer>
                <Form.Group as={Col} controlId="formGridName" className="d-flex justify-content-center">
                    <Button onClick={() => addSpc(spc)}>NOVA CONSULTA</Button>
                </Form.Group>
            </Modal.Footer>
            <ModalDesaprovedSpc key={String("DeleteCont_" + index.id)} props={index} show={modalDesaprovedSpc} onHide={() => setModalDesaprovedSpc(false)} handleShowContact={() => { }} loadSpc={() => loadSpc()} />
            <ModalUpdateSpc key={String("UpdCont_" + index.id)} props={index} show={modalUpdateSpc} onHide={() => setModalUpdateSpc(false)} handleShowContacts={() => { }} loadSpc={() => loadSpc()} />
        </Modal>
    );
}

export default ModalViewContacts;